import {memo} from 'react'
import type {EntryPointProps} from 'react-relay'

import {useBuildId, useBuildTypeId} from '../../../../hooks/routes'
import {PlaceIdList} from '../../../../pluginSystem/pluginSystem.types'
import Loader from '../../../common/Loader/Loader'
import Plugin from '../../../common/Plugin/Plugin'
import SequenceLoader from '../../../common/SequenceLoader/SequenceLoader'
import type {CommiterSelectQuery} from '../../../common/UserSelect/__generated__/CommiterSelectQuery.graphql'

import ChangesAdvancedView from './ChangesAdvancedView/ChangesAdvancedView'
import ChangesRevisions from './ChangesRevisions/ChangesRevisions'

type Queries = {
  commiterSelect: CommiterSelectQuery
}

type ExtraProps = {
  baseLocator: string
}

function BuildChangesTab({queries, extraProps}: EntryPointProps<Queries, {}, {}, ExtraProps>) {
  const buildId = useBuildId()
  const buildTypeId = useBuildTypeId()
  return (
    <>
      <Plugin placeId={PlaceIdList.SAKURA_BUILD_CHANGES} />
      {buildId != null && buildTypeId != null ? (
        <SequenceLoader loader={<Loader />}>
          <ChangesRevisions seqKey="Revisions" buildId={buildId} />
          <ChangesAdvancedView
            seqKey="Changes"
            buildId={buildId}
            buildTypeId={buildTypeId}
            commiterSelectQueryRef={queries.commiterSelect}
            baseLocator={extraProps.baseLocator}
          />
        </SequenceLoader>
      ) : null}
    </>
  )
}

export type BuildChangesTabComponent = typeof BuildChangesTab

export default memo(BuildChangesTab)
